export type BudgetPeriodType = 'months' | 'month' | 'week' | 'day';

export interface IBudgetReviewFilter {
    periodType: BudgetPeriodType;
    endDate: string;
}

export const BUDGET_PERIOD_OPTIONS: {
    value: BudgetPeriodType;
    label: string;
}[] = [
    { value: 'months', label: 'Last 6 months' },
    { value: 'day', label: 'Last day' },
    { value: 'week', label: 'Last week' },
    { value: 'month', label: 'Last month' }
];

export const DEFAULT_BUDGET_REVIEW_FILTER: IBudgetReviewFilter = {
    periodType: 'months',
    endDate: new Date().toISOString().slice(0, 10)
};

export const getBudgetReviewDescription = (periodType: BudgetPeriodType) => {
    const periodLabel =
        periodType === 'months'
            ? 'Monthly'
            : periodType === 'month'
              ? 'Weekly (last month)'
              : periodType === 'week'
                ? 'Daily (last week)'
                : 'Daily';

    return `${periodLabel} breakdown: Contributors data is cross referenced upwork diaries with our work record logs (using tasks project tag).
        Core Team and Others (e.g QA Contributions) are derived from external Google Form manual logging.`;
};
